<template lang="pug">
  .userEdit
    .row
      .col-md-4.col-md-offset-4
        h1 {{lang['Edit user']}}
        .form-group
          label {{lang['User name']}}
          input.form-control(type="text" v-model="user.nick")
        .form-group
          label {{lang['Email']}}
          input.form-control(type="email" v-model="user.email")
        h3 {{lang['Role']}}
        .radio(v-for="(role, index) in roles")
          label
            input(type="radio" name="roles" :value="role.id" v-model="roleSel")
            | {{role.name}}
        h3 {{lang['Networks']}}
        .checkbox
          label
            input(type="checkbox" @change="changeAllNetworks()")
            | {{lang['All networks']}}
        hr
        .checkbox(v-for="(network, index) in networks" :key="index")
          label
            input(type="checkbox" :id="network.id" :value="network.id" v-model="user.networks")
            | {{network.name}}
        transition(name="fade" mode="out-in")
          div
            button.btn.btn-primary(@click="saveUser()") {{lang['Save user']}}
            button.btn.btn-default(@click="$router.push('/userlist')")
              i.fa.fa-chevron-left
              | &nbsp;&nbsp;{{lang['Return to list']}}
        .small
          sup *
          | {{lang['all fields required']}}
</template>
<script>
export default {
  name: 'userEdit',
  props: ['lang'],
  data () {
    return {
      user: {},
      all: false,
      roles: [],
      roleSel: null,
      networks: []
    }
  },
  methods: {
    changeAllNetworks () {
      if (this.all) {
        this.user.networks = []
        this.all = false
      } else {
        this.user.networks = this.networks.map((n) => n.id)
        this.all = true
      }
    },
    saveUser () {
      const user4update = JSON.parse(JSON.stringify(this.user))
      if (!this.roleSel) {
        return this.$notify(`${this.lang['Select role']} `, 'error')
      }
      if (!this.user.networks.length) {
        return this.$notify(`${this.lang['Select network']} `, 'error')
      }
      // prepare data
      user4update.roles = [this.roles.find((e) => e.id === this.roleSel).id]
      this.$http.patch(`user/${user4update.id}`, user4update)
        .then(response => {
          console.info(response)
          if (response.ok) {
            this.$notify(`${this.lang['User updated']} `, 'success')
          }
        })
        .catch(data => {
          if (data.body) {
            switch (data.body.code) {
              case 'E_UNIQUE':
                const field = []
                switch (true) {
                  case data.body.attrNames.includes('nick'):
                    field.push(this.lang['User name'])
                    break
                  case data.body.attrNames.includes('email'):
                    field.push(this.lang['Email'])
                    break
                }
                this.$notify(`${this.lang['Error, field']} "${field.join(',')}" ${this.lang['with this values exists']} `, 'error')
                break
              case 'E_INVALID_VALUES_TO_SET':
                this.$notify(`${this.lang['Invalid values']} `, 'error')
                break
            }
          }
        })
    }
  },
  beforeCreate () {
    this.$http.get('network')
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.networks = data
      })
    this.$http.get('role/short')
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.roles = data
      })
    this.$http.get(`user/${this.$route.params.userId}`)
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.roleSel = data.roles[0].id
        this.user = data
      })
  }
}
</script>
<style lang="sass">
@import "~sass/_variables"
.userEdit
  .btn
    margin-right: 20px
  .small
    margin-top: 20px
</style>



// WEBPACK FOOTER //
// src/components/user/UserEdit.vue